export default {
  name: 'organisations/details',
}
